import { isArray } from 'lodash';

export const isMarkedTrack = (state: { index: number; value: number | number[] }): boolean => {
  const idx = state && isArray(state.value) && state.value.length === 2 ? 1 : 0;
  return state.index === idx;
};
